import { useAppDispatch, useAppSelector } from '../../store/types'
import { getGridDefinition } from '../../store/securities/selectors'
import { getWatchlistDetails } from '../../store/watchList/selectors'
import { useEffect } from 'react'
import { fetchWatchlistDetails } from '../../store/watchList/actions'

export default (gridIndex: number) => {
  const dispatch = useAppDispatch()
  const gridDefinition = useAppSelector(getGridDefinition)(gridIndex)
  const watchListId = gridDefinition?.watchlistId ?? -1
  const watchlist = useAppSelector(getWatchlistDetails)(watchListId)
  useEffect(() => {
    if (watchListId >= 0 && !watchlist) {
      dispatch(fetchWatchlistDetails(watchListId, gridIndex))
    }
  }, [])
  return { watchlist, gridDefinition }
}
